function copyToClipboardHandlerFallback(text: string) {
  const textArea = document.createElement('textarea');

  textArea.value = text;

  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);

  textArea.focus();
  textArea.focus();

  try {
    const result = document.execCommand('copy');

    document.body.removeChild(textArea);

    return result;
  } catch (err) {
    document.body.removeChild(textArea);

    return false;
  }
}

export async function copyToClipboardHandler(text: string): Promise<boolean> {
  if (!navigator.clipboard) {
    return copyToClipboardHandlerFallback(text);
  }

  try {
    await navigator.clipboard.writeText(text);

    return true;
  } catch (error) {
    return false;
  }
}
